// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect x=\"1.75\" y=\"4.75\" width=\"20.5\" height=\"14.5\" rx=\"1.25\" stroke=\"white\" stroke-width=\"1.5\"/>\n</svg>\n";
// Exports
module.exports = code;